import { useEffect, useState } from "react";
import { AlertTriangle, EyeOff, Trash2, Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function DemoDataCard() {
  const [sum, setSum] = useState(null);
  const [busy, setBusy] = useState("");

  const load = () => api.get("/control/demo/summary").then((r) => setSum(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const run = async (mode) => {
    const msg = mode === "wipe"
      ? "Permanently DELETE all demo accounts, listings, storefronts and their bookings? This cannot be undone."
      : "Hide all demo accounts and listings from the live site (disable accounts, deactivate listings)?";
    if (!window.confirm(msg)) return;
    setBusy(mode);
    try {
      const r = await api.post("/control/demo/purge", { mode });
      toast.success(mode === "wipe" ? "Demo data wiped" : "Demo data hidden", { description: JSON.stringify(r.data).slice(0, 120) });
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setBusy(""); }
  };

  return (
    <div className="mt-6 rounded-2xl border border-amber-200 bg-amber-50/50 p-5" data-testid="demo-data-card">
      <p className="flex items-center gap-1.5 text-sm font-bold text-amber-800"><AlertTriangle className="h-4 w-4" /> Demo data — go-live cleanup</p>
      <p className="mt-0.5 text-xs text-amber-700/80">Demo accounts and their listings are already hidden from public pages. Before go-live you can hide them fully or wipe them entirely so nothing demo remains on the live site.</p>
      {sum && (
        <p className="mt-2 text-xs font-semibold text-slate-600" data-testid="demo-data-counts">
          {sum.users} demo account(s) · {sum.services} listing(s) · {sum.products} product(s) · {sum.storefronts} storefront(s)
        </p>
      )}
      <div className="mt-3 flex flex-wrap gap-2">
        <button onClick={() => run("hide")} disabled={!!busy} data-testid="demo-hide-btn" className="inline-flex items-center gap-1.5 rounded-full border border-amber-300 bg-white px-4 py-2 text-xs font-semibold text-amber-700 hover:border-amber-400 disabled:opacity-50">
          {busy === "hide" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <EyeOff className="h-3.5 w-3.5" />} Hide demo content
        </button>
        <button onClick={() => run("wipe")} disabled={!!busy} data-testid="demo-wipe-btn" className="inline-flex items-center gap-1.5 rounded-full bg-rose-600 px-4 py-2 text-xs font-semibold text-white hover:bg-rose-700 disabled:opacity-50">
          {busy === "wipe" ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Trash2 className="h-3.5 w-3.5" />} Wipe demo content
        </button>
      </div>
    </div>
  );
}
